import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { GatePassRequestsService } from '../../gate-pass-requests.service';
import { SharedService } from 'src/app/core/services';
import { takeUntil } from 'rxjs/operators';
import { ContractorType, GatePassAccociateInformation, GatepassRequestProcess } from "../gatepass-request-process.model";
import { GatepassRequestProcessService } from '../gatepass-request-process.service';
import { GLOBAL } from 'src/app/app.globals';
import { DataShareService } from 'src/app/service/data-share.service';

@Component({
  selector: 'app-process-gatepass-request',
  templateUrl: './process-gatepass-request.component.html',
  styleUrls: ['./process-gatepass-request.component.css'],
  providers: [GatepassRequestProcessService]
})
export class ProcessGatepassRequestComponent implements OnInit {

  @Input() requestType: number;
  @Input() contractorList: any[] = [];
  @Input() contractorInformation: any;
  @Input() userSiteCode: any;

  @Output() handleClose: EventEmitter<void>;

  private destroy: Subject<void>;

  stateCapacityCheck: any;
  checkConditionForRemaining: any;
  selectedPlantDetail: any;
  workOrderCode: any;
  contractorCode: any;

  useRoles: any[] = [];
  globalSettings: any[] = [];
  alertMessages: any[] = [];
  workorderList: any[] = [];
  plantList: any[] = [];
  licenseList: any[] = [];
  wcPolicyList: any[] = [];
  associateList: any[] = [];

  isContractor: boolean;
  isDisableWorkOrderPrevBtn: boolean;
  isDisableContractorPrevBtn: boolean;
  isResingationInput: boolean;

  allStepDataObj: GatepassRequestProcess = {};

  currentStep: number = 0;

  constructor(
    public gatepassService: GatePassRequestsService,
    private sharedService: SharedService,
    private gatePassRequestProcessService: GatepassRequestProcessService,
    private dataShareService: DataShareService,
  ) {
    this.handleClose = new EventEmitter<void>();
    this.destroy = new Subject<void>();
    this.useRoles = this.getCurrentUserRoles();
    this.isContractor = this.useRoles.some(item => item.Role_Code === 119);
    if (this.isContractor) {
      this.allStepDataObj = { ...this.allStepDataObj };
    }
  }

  ngOnInit() {
    this.allStepDataObj = { ...this.allStepDataObj, requestType: this.requestType };
    this.gatepassService.getRequestTypeText(this.allStepDataObj);
    this.checkGlobalSettingsForVisibility();
    this.getAlertMessageFromGlobalSource();
    this.stateCapacityCheck = this.globalSettings.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
    this.checkConditionForRemaining = this.globalSettings.find(item => item.Code === 'MOD52PG195REQWOCAP').Value;
  }

  checkGlobalSettingsForVisibility(): void {
    this.sharedService.globalSettingsDataSource$.subscribe((settings: any) => {
      if (settings && settings.Data && settings.Data.Table) {
        this.globalSettings = settings.Data.Table;
        this.checkSettingForFirstStep(settings.Data.Table);
        this.checkSettingForResignationInput(settings.Data.Table);
      }
    });
  }

  getAlertMessageFromGlobalSource(): void {
    this.sharedService.alertMessages$.subscribe((alertMessages: any[]) => {
      this.alertMessages = alertMessages;
    });
  }

  checkSettingForFirstStep(settings: any[]): void {
    const data = settings.find(item => item.Code === 'MOD52PG195REQSUBCON');
    if (data) {
      let value = data.Value;
      if (this.userSiteCode === data.Plant_Code) {
        value = data.Value;
      }
      if (value === '1') {
        this.currentStep = 1;
        this.getContractors();
      } else if (this.isContractor) {
        this.allStepDataObj = { ...this.allStepDataObj, contractorType: ContractorType.Contractor };
        this.isDisableWorkOrderPrevBtn = true;
        this.getContractors(1, true);
      } else {
        this.allStepDataObj = { ...this.allStepDataObj, contractorType: ContractorType.Contractor };
        this.currentStep = 2;
        this.isDisableContractorPrevBtn = true;
        this.getContractors();
      }
    }
  }

  getContractors(isMain = 1, isCallContractorSelection: boolean = false): void {
    if (this.useRoles) {
      const reuqestObj = this.createContractorListRequest(this.allStepDataObj, isMain)
      this.gatePassRequestProcessService.getContractors(reuqestObj)
        .pipe(takeUntil(this.destroy))
        .subscribe(res => {
          this.contractorList = res;
          if (res && res.length > 0 && isCallContractorSelection) {
            this.onContractorSelection({ ContractorVendor_Code: this.contractorList[0].ContractorVendor_Code, Company: this.contractorList[0].Company });
          }
        })
    }
  }

  checkSettingForResignationInput(settings: any[]): void {
    const data = settings.find(item => item.Code === 'MOD152PG198C100FV1');
    if (data && this.allStepDataObj.requestType === 105) {
      this.isResingationInput = !!(+data.Value);
    }
  }

  createContractorListRequest({ ContractorVendor_Code = null, WorkOrder_Code = null, contractorType }: GatepassRequestProcess, isMain): any {
    this.contractorCode = ContractorVendor_Code;
    return {
      search: null,
      sDate: null,
      eDate: null,
      selectedField: 'Company,ContractorVendor_Code,EmailID,ShortCode,PANNo,IsContactor,Status',
      isMain,
      Contractor_Code: isMain === 1 ? null : ContractorVendor_Code,
      ExcludeContractor_Code: isMain === 1 ? null : ContractorVendor_Code,
      workOrderCode: WorkOrder_Code,
      Plant_Code: null,
      UserID: GLOBAL.USER_ID,
      RequirType: null
    }
  }

  onContractorSelection(data: any): void {
    this.dataShareService.contractorFlowArrayDataShareService.push(data);
    const newObj: GatepassRequestProcess = {
      ...(this.allStepDataObj.isSubContractorFlowStarted && { SubContractor_Code: data.ContractorVendor_Code, SubCompany: data.Company }),
      ...(!this.allStepDataObj.isSubContractorFlowStarted && { ContractorVendor_Code: data.ContractorVendor_Code, Company: data.Company })
    };
    
    this.allStepDataObj = { ...this.allStepDataObj, ...newObj };
    // const requestObj = this.createWorkOrderListRequest(this.allStepDataObj);
    // this.gatePassRequestProcessService.getWorkOrders(requestObj).subscribe((res: any) => {
    //   if (res) {
    //     this.workorderList = res;
    //     this.currentStep = 3;
    //   }
    // });
  }

  onAccociateInformationChange({ contractorType }: GatePassAccociateInformation): void {
    this.allStepDataObj = { ...this.allStepDataObj, contractorType: contractorType, Role_Code: this.useRoles[0].Role_Code };
    if (this.isContractor) {
      this.getContractors(1, true);
      this.allStepDataObj = { ...this.allStepDataObj, contractorType: contractorType, ContractorVendor_Code: this.contractorInformation.ContractorVendor_Code };
      this.currentStep = 3;
    } else {
      this.allStepDataObj = { ...this.allStepDataObj, contractorType: contractorType };
      this.currentStep = 2;
    }
  }

  getCurrentUserRoles(): any {
    return JSON.parse(localStorage.getItem('Role'));
  }

  onPrevAction(step: number): void {
    this.currentStep = step;
  }
  
  onClose(data?: any): void {
    this.dataShareService.contractorFlowArrayDataShareService = [];
    this.dataShareService.workOrderFlowArrayDataShareService = [];
    this.dataShareService.newLicenseFlowArrayDataShareService = [];
    this.dataShareService.oldLicenseFlowArrayDataShareService = [];
    this.handleClose.emit(data);
  }
}
